<template>
    <div class="position-relative p-3 h-100">
        <!-- <div class="Medication-section position-relative" v-else-if="(!pageLoader && prescriptionList.hasOwnProperty('totalRecords') && prescriptionList.totalRecords == 0)">
            <div class="row">
                <div class="col-md-7 col-12 mb-4">
                    <div class="card border-0 h-100">
                        <div class="card-body p-3 text-center d-flex justify-content-center align-items-center">
                            <div class="text-center w-100">
                                <h2>Analyze Your Medication</h2>
                                <ul class="mb-0 d-flex mt-3 Upload-Prescription justify-content-center">
                                    <li class="text-left">
                                        <router-link to="/upload-prescription" class="d-flex align-items-center">
                                            <span class="icon"><i class="icon icon-upload-prescription"></i></span>
                                            <h6 class="mb-0">Upload Prescription</h6>
                                        </router-link>
                                        <p class="mt-2">Supported files type: jpeg , jpg , png , pdf</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-12 mb-4 text-left valid-prescription">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3 text-left">
                            <h2>Guide for a valid prescription</h2>
                            <figure><img src="../../../../static/website/images/gini-prescription.svg" /></figure>
                            <h3>Note: Prescription should contain</h3>
                            <ul class="mb-0">
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Doctor Name and Signature
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Patient Name
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Date of Prescription
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Don't crop out any part of the image
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Avoid blurred image
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Include Details of doctor and patient + clinic visit date
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Medicines will be dispensed as per prescription
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
       <!--  <no-record v-else-if="(!pageLoader && prescriptionList.hasOwnProperty('totalRecords') && prescriptionList.totalRecords == 0)"></no-record> -->
        <div class="prescription-section position-relative">
           <!--  <div class="fixedTop nav-item d-flex justify-content-end">
              <router-link class="themecolor whiteButton d-inline-flex align-items-center justify-content-end medium" to="/upload-prescription"><span class="plusCircle mb-0 bg-white mr-2"><i class="icon icon-plus mr-1"></i></span> Add New Prescription</router-link>
            </div> -->
            <div class="row">
                <div class="col-12 mb-4">
                    <!-- <div class="bg-white border-radius-5 p-4"> -->
                    <div class="card-body h-100">
                        
                        <!-- Tab panes -->
                        <div class="table-reponsive">
                            <table class="table separateTable">
                                <thead>
                                    <tr>
                                      <th>Created</th>
                                      <th>Prescription</th>
                                      <th>Quantity</th>
                                      <th>Dosage</th>
                                      <th>Strength</th>
                                      <th>Route of Administration</th>
                                      <th>How many times</th>
                                      <th>Instruction</th>
                                      <th>Duration</th>
                                      <th>Precautions</th>
                                      <th>Comments</th>
                                      <!-- <th>Action</th> -->
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader ></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && !prescriptionList.totalRecords">
                                    <no-record :type="'table'" :colspan="11"></no-record>
                                </tbody>
                                <tbody v-else>
                                    <tr v-for="list in prescriptionList.records">
                                        <td class="text-nowrap">
                                           <p class="d-inline-flex align-items-center"><feather class="mr-1" size="15px" type="calendar"></feather>{{list.created | moment("DD-MM-YYYY")}}</p>
                                        </td>
                                        <td>
                                            <p v-html="(list.medicine !='' && list.medicine != null)? list.medicine :'-'"></p>
                                        </td>
                                        <td>
                                            <p v-html="(list.quantity !='' && list.quantity != null)? list.quantity :'-'"></p>
                                        </td>
                                        <td>
                                            <p v-html="(list.dosage !='' && list.dosage != null  && medicineList['dosages'] )? medicineList['dosages'][list.dosage] :'-'"></p>
                                        </td>
                                        <td>
                                            <p v-html="((list.strength !='' && list.strength != null  && medicineList['strength'] )? (list.strength_other != '' && list.strength_other != null)? list.strength_other : medicineList['strength'][list.strength] :'-')"></p>
                                        </td>
                                        <td>
                                            <p v-html="((list.route_adm !='' && list.route_adm != null  && medicineList['role_of_administrator'] )? (list.route_adm_other != '' && list.route_adm_other != null)?  list.route_adm_other : medicineList['role_of_administrator'][list.route_adm] :'-')"></p>
                                        </td>
                                        <td>
                                            <p v-html="((list.time_to_take !='' && list.time_to_take != null  && medicineList['how_many_times_a_day'] )? (list.time_to_take_other != '' && list.time_to_take_other != null)?  list.time_to_take_other : medicineList['how_many_times_a_day'][list.time_to_take] :'-')"></p>
                                        </td>
                                        <td>
                                            <p v-html="((list.instruction !='' && list.instruction != null  && medicineList['instruction'] )? (list.instruction_other != '' && list.instruction_other != null)?  list.instruction_other : medicineList['instruction'][list.instruction] :'-')"></p>
                                        </td>
                                        <td>
                                            <p v-if="list.duration != '' && list.duration != null && list.duration_val != '' && list.duration_val != null">{{list.duration}} {{list.duration_val}}</p>
                                        </td>
                                        <td>
                                            <p v-html="(list.precautions !='' && list.precautions != null  && medicineList['precaution'] )? GetPrecautions(list.precautions,list.precautions_other) :'-'"></p>
                                        </td>
                                        <td>
                                            <p v-html="(list.notes !='' && list.notes != null)? list.notes :'-'"></p>
                                        </td>
                                        <!-- <td>
                                            <div class="btnEdit">
                                                <a :href="$env_var.doc_link + '?id=' + list.user_id + '&img=' + list.document" target="_blank"><feather type="eye"></feather></a>
                                            </div>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <app-pagination :totalRecords="prescriptionList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="prescriptionList.totalRecords && prescriptionList.totalRecords > pageLimit"/>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "prescription",
        data() {
            return {
                "pageLoader" : false,
                page : 1,
                pageLimit : 10,
            };
        },
        methods:{
            GetPrecautions(getdata,others){
                if(JSON.parse(getdata).length > 0){
                    let data =  JSON.parse(getdata).join().split(',')
                    let arr = []
                    data.forEach(val =>{
                        if(val == '51' && others){
                            arr.push(others)
                        }else{
                            arr.push(this.medicineList.precaution[val])
                        }
                    })
                    return arr.join(',')
                }else{
                    return '-'
                }
            },
            listing(){
                let sendData = {
                    'globalParams' : {
                        'limit': this.pageLimit,
                        'page': this.page
                    },
                    'localParams' : { 'parameter' : this }
                }
                this._runGetPatientPrescriptionList(sendData);
            }
        },
        created() {
            this.pageName("Prescription");
            this.listing()
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription.vue